import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getContentPropertyValue, CONTENT_PLATFORM_PROPERTY_NAME, contentIsScheduled, contentIsPublishedWithScheduledUpdate, useContentObjectType, useAuthInfoProvider } from 'content-management-data-lib';
import { getContentLayoutId } from '../../utils/contentObjectUtils';
import useFetchTemplateForContent from '../../hooks/useFetchTemplateForContent';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HeaderDetailInfoRow = ({
  children,
  titleKey
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("dt", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `content-management-details-lib.header.headerDetails.${titleKey}`
      })
    }), /*#__PURE__*/_jsx("dd", {
      children: children
    })]
  });
};
export const HeaderDetailDateRow = ({
  titleKey,
  date
}) => {
  return date ? /*#__PURE__*/_jsx(HeaderDetailInfoRow, {
    titleKey: titleKey,
    children: /*#__PURE__*/_jsx(FormattedDateTime, {
      format: "LLL",
      type: "portalTz",
      value: date
    })
  }) : null;
};
export const PublishedDatesDetailRow = ({
  contentObject
}) => {
  const {
    getIsUngatedToUseResolvedStateProperty
  } = useAuthInfoProvider();
  const isUngatedToUseResolvedStateProperty = getIsUngatedToUseResolvedStateProperty();
  const publishDate = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.PUBLISH_DATE);
  const isScheduled = contentIsScheduled(contentObject, isUngatedToUseResolvedStateProperty);
  const scheduledPublishDate = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.SCHEDULED_PUBLISH_DATE);
  const isPublishedWithScheduledUpdate = contentIsPublishedWithScheduledUpdate(contentObject, isUngatedToUseResolvedStateProperty);
  const date = isScheduled ? scheduledPublishDate : publishDate;
  return date ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HeaderDetailDateRow, {
      titleKey: isScheduled ? 'scheduledPublishDate' : 'publishDate',
      date: date
    }), /*#__PURE__*/_jsx(HeaderDetailDateRow, {
      titleKey: "scheduledUpdateDate",
      date: isPublishedWithScheduledUpdate ? scheduledPublishDate : undefined
    })]
  }) : null;
};
export const TemplateRowMessage = ({
  contentObject
}) => {
  const {
    contentObjectType
  } = useContentObjectType();
  const templatePath = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.TEMPLATE_PATH);
  const layoutId = getContentLayoutId(contentObject);
  const {
    template
  } = useFetchTemplateForContent({
    contentObjectType,
    templatePath,
    layoutId
  });
  if (!template || !template.url) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "content-management-details-lib.header.headerDetails.missingTemplate"
    });
  }
  const {
    url,
    label,
    isStarterTemplate
  } = template;
  const templateLink = /*#__PURE__*/_jsx(Link, {
    disabled: isStarterTemplate,
    external: true,
    href: url,
    children: label
  });
  if (isStarterTemplate) {
    return /*#__PURE__*/_jsx(Tooltip, {
      placement: "bottom",
      title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link
        },
        message: "content-management-details-lib.header.headerDetails.disabledStarterTemplateLinkTooltip_jsx"
      }),
      children: templateLink
    });
  }
  return templateLink;
};
export const HeaderDetailsRows = ({
  contentObject,
  detailsRenderConfig
}) => {
  const rows = Object.keys(detailsRenderConfig).reduce((acc, row) => {
    const {
      hidden,
      Title,
      Description
    } = detailsRenderConfig[row];
    if (!hidden) {
      acc.push( /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("dt", {
          children: /*#__PURE__*/_jsx(Title, {
            contentObject: contentObject
          })
        }), /*#__PURE__*/_jsx("dd", {
          children: /*#__PURE__*/_jsx(Description, {
            contentObject: contentObject
          })
        })]
      }, `row-${row}`));
    }
    return acc;
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: rows
  });
};